export class OtroDescuento{
    constructor(
        public id: number,
        public nombre: string,
        public descuento: string,
        public tipo: string,
        public tipoAplicacion: string
    ){}
}